module.exports = __webpack_public_path__ + "static/media/left-arrow.dd8c203c.svg";